<script setup>
// This starter template is using Vue 3 <script setup> SFCs
// Check out https://v3.vuejs.org/api/sfc-script-setup.html#sfc-script-setup
import JakeSeatForm from "./components/JakeSeatOrder.vue";
import {store} from "./components/store.js";
import DebugMenu from "@/components/DebugMenu.vue";
const local = process.env.NODE_ENV === 'development';
const swissUrl = import.meta.env.VITE_JAKE_SWISS_URL;
import {useI18n} from "vue-i18n";
const {t, locale} = useI18n({useScope: 'global'})
const logStore = () =>{
  console.log(store)
}
</script>
<template>
<!--    <DebugMenu/>-->
  <div v-if="local"><b>swissUrl: {{swissUrl}} </b> <button @click="locale = 'en'">en</button><button @click="locale = 'cs'">cs</button><button @click="locale = 'sk'">sk</button><button @click="locale = 'pl'">pl</button><button @click="locale = 'de'">de</button><button @click="logStore">log store</button></div>
  <JakeSeatForm/>
</template>

<style lang="scss">
@import './assets/scss/style';
</style>
